import api from "@/lib/axios";

export const formService = {
  // Get form structure for a specific user
  async getUserForm(userId) {
    try {
      const response = await api.get(`/myform/${userId}`);
      return response.data;
    } catch (error) {
      // Check for specific error messages and re-throw with the exact message
      if (error.response?.data?.message) {
        const errorMessage = error.response.data.message;
        if (errorMessage === "No video found" || 
            errorMessage === "No transcription found" || 
            errorMessage === "Form not found") {
          // Re-throw the error with the specific message preserved
          const preservedError = new Error(errorMessage);
          preservedError.response = error.response;
          throw preservedError;
        }
      }
      
      throw error;
    }
  },

  // Alternative endpoint if form is still ID-based but user-specific
  async getForm(formId) {
    const response = await api.get(`/v1/forms/${formId}`);
    return response.data;
  },

  async getAllForms() {
    const response = await api.get('/v1/forms');
    return response.data;
  },

  async createForm(data) {
    const response = await api.post('/v1/forms', data);
    return response.data;
  },

  async updateForm(id, data) {
    const response = await api.put(`/v1/forms/${id}`, data);
    return response.data;
  },

  async deleteForm(id) {
    const response = await api.delete(`/v1/forms/${id}`);
    return response.data;
  },

  async submitForm(id, data) {
    const response = await api.post(`/v1/forms/${id}/submit`, data);
    return response.data;
  },

  async getInitialFormSubmission(formId) {
    const response = await api.post(`/v1/initial-form-submission/${formId}`);
    return response.data;
  },

  async getStreamTranscription(userId) {
    const response = await api.get(`/stream-transcription/${userId}`);
    return response.data;
  }
}; 